<template>
  <div class="main">

    <div class="background-class" :style="{backgroundImage: `url(${backgroundImg})`}">
      <!--      <img :src="backgroundImg" class="" alt=""/>-->
    </div>

    <div class="app-content">

      <div class="app-card weather">
        <weather></weather>
      </div>

      <div class="app-card news">
        <news></news>
      </div>

      <div class="app-card calendar">
        <calendar></calendar>
      </div>

      <div class="app-card count-down">
        <count-down></count-down>
      </div>

    </div>
  </div>
</template>

<script>
import Weather from '@/components/home/weather'
import Calendar from '@/components/home/calendar'
import countDown from '@/components/home/countDown'
import News from '@/components/home/news'
import {basUrl} from "@/api/env";

export default {
  data: () => ({
    backgroundImg: basUrl + "/img/bing"
  }),
  components: {
    Weather,
    Calendar,
    'count-down': countDown,
    News
  },

}
</script>

<style scoped>
.main {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.app-content {
  position: relative;
  padding-top: 4vh;
  display: grid;
  justify-content: center;
  grid-auto-flow: dense;
  grid-template-rows:repeat(auto-fill, calc(85px));
  grid-template-columns: repeat(auto-fill, calc(85px));
  margin: auto;
  height: 100%;
  max-width: 1300px;
}

.app-card {
  width: 100%;
  height: 100%;
  margin: auto;
  padding: 5px;
  max-width: 385px;
}

.app-card.weather {
  grid-column: span 5;
  grid-row: span 6;
}

.app-card.news {
  grid-column: span 5;
  grid-row: span 6;
}

.app-card.calendar {
  grid-column: span 5;
  grid-row: span 3;
}

.app-card.count-down {
  grid-column: span 5;
  grid-row: span 3;
}

.background-class {
  position: absolute;
  left: calc(4px * -6);
  top: calc(4px * -6);
  right: calc(4px * -6);
  bottom: calc(4px * -6);
  filter: blur(6px);
  transition: background-image .3s, background-color .2s, transform .3s;
  background-size: cover;
  background-position: 50%;
  z-index: 0;
  -moz-background-size: 100% 100%;
}

/*.background-class.change {*/
/*  transform: scale(1.1)*/
/*}*/

/*.background-class:after {*/
/*  display: block;*/
/*  content: '';*/
/*  position: absolute;*/
/*  left: 0;*/
/*  top: 0;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  background-color: rgba(0, 0, 0, 0.3);*/
/*}*/


</style>
